<template>
  <aside class="toc-sidebar">
    <div :class="toc">
      <div
        v-for="(item, index) in toc"
        :key="index"
        :class="isSelected(item.id) && 'toc-selected'"
        v-if="subPath.split('-')[0] === '#' + item.id"
      >
        <a
          :href="'#' + item.id"
          @click="changeSelectedToc(item, index)"
          :class="`li1 ${selectedMainId === item.id ? 'itemSelected' : ''}`"
        >
          <span>{{ item.title }}</span>
        </a>
        <div>
          <div v-for="(sub, subIndex) in item.childs" :key="subIndex">
            <a
              :href="'#' + sub.id"
              @click="changeSelectedSubToc(sub, index, subIndex)"
              :class="`li2 ${selectedSubId === sub.id ? 'subSelected' : ''}`"
            >
              <span>{{ sub.title }}</span>
            </a>
            <div>
              <div
                v-for="(subChild, subChildIndex) in sub.childs"
                :key="subChildIndex"
              >
                <a
                  :href="`#${subChild.id}`"
                  @click="changeSelectedSubSubToc(subChild)"
                  :class="`li3 ${selectedSubSubId === subChild.id ? 'subChildSelected' : ''}`"
                >
                  {{ subChild.title }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import manual_contents from "@/assets/docs/ca2-user-manual/manual_contents.json";

export default {
  name: "ManualRightSideBar",
  props: {
    loadManual: {
      type: Function,
      required: true,
    },
    subPath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toc: manual_contents,
      expanded: [],
      expandedSub: {},
      selectedSection: null,
      selectedMainId: null,
      selectedSubId: null,
      selectedSubSubId: null,
    };
  },
  mounted() {
    this.selectedSection = this.toc.map(
      (section) => "#" + section.id == this.subPath
    );
    if (
    this.selectedMainId === null &&
    this.selectedSubId === null &&
    this.selectedSubSubId === null
  ) {
    this.$emit("update:subPath", "#1");
    this.selectedMainId = "1";
    this.loadManual(this.toc.find((item) => item.id === "1").md);
  }
  },
  created() {
    this.checkContent();
  },
  methods: {
    checkContent() {
      this.expanded = Array(this.toc.length).fill(false);
      const mainIndex = this.toc.findIndex((item) => this.isSelected(item.id));
      if (mainIndex === -1) return;
      const currentToc = this.toc[mainIndex];
      this.expanded[mainIndex] = true;
      const subIndex = currentToc.childs.findIndex((sub) =>
        this.isSelected(sub.id)
      );
      this.expandedSub[`${mainIndex}_${subIndex}`] = true;
      this.loadManual(currentToc.md);
    },
    toggleSection(index) {
      const isExpand = this.expanded[index];
      this.expanded = Array(this.toc.length).fill(false);
      this.$set(this.expanded, index, !isExpand);
    },
    toggleSub(mainIndex, subIndex) {
      const key = `${mainIndex}_${subIndex}`;
      if (this.expandedSub.hasOwnProperty(key)) {
        const isExpand = this.expandedSub[key];
        this.expandedSub = { key: !isExpand };
      } else {
        this.expandedSub = {};
        this.expandedSub[key] = true;
      }
    },
    isSubExpanded(mainIndex, subIndex) {
      return this.expandedSub[`${mainIndex}_${subIndex}`];
    },
    changeSelectedToc(item, index) {
      this.toggleSection(index);
      this.selectedMainId = item.id;
      this.selectedSubId = null;
      this.selectedSubSubId = null;
      this.loadManual(item.md);
    },
    changeSelectedSubToc(sub, mainIndex, subIndex) {
      this.toggleSub(mainIndex, subIndex);
      this.selectedSubId = sub.id;
      this.selectedMainId = null;
      this.selectedSubSubId = null;
      this.loadManual(item.md);
    },
    changeSelectedSubSubToc(subChild) {
      this.selectedMainId = null;
      this.selectedSubId = null;
      this.selectedSubSubId = subChild.id;
      this.loadManual(item.md);
    },
    isMainSelected(id) {
      return this.subPath === `#${id}`;
    },
    isSelected(id) {
      return this.selectedMainId === id || this.selectedSubId === id;
    },
  },
  watch: {
  subPath(newVal) {
    const id = newVal.replace('#', '');
    let matched = false;

    for (const item of this.toc) {
      if (item.id === id) {
        this.selectedMainId = item.id;
        this.selectedSubId = null;
        this.selectedSubSubId = null;
        matched = true;
        break;
      }

      for (const sub of item.childs || []) {
        if (sub.id === id) {
          this.selectedMainId = null;
          this.selectedSubId = sub.id;
          this.selectedSubSubId = null;
          matched = true;
          break;
        }

        for (const subChild of sub.childs || []) {
          if (subChild.id === id) {
            this.selectedMainId = null;
            this.selectedSubId = null;
            this.selectedSubSubId = subChild.id;
            matched = true;
            break;
          }
        }

        if (matched) break;
      }

      if (matched) break;
    }

    this.checkContent();
  },
},

};
</script>

<style scoped lang="scss">
.toc-sidebar {
  width: 18%;
  overflow-y: auto;
  padding-top: 20px;
}

.toc {
  display: flex;
  flex-direction: column;
}

.li1,
.li2,
.li3 {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
}

.li1 {
  padding: 0.5rem 2rem;
  font-size: 16px;
}

.li2 {
  padding: 0.5rem 2rem 0.5rem 3rem;
  font-size: 14px;
}

.li3 {
  padding: 0.5rem 4rem;
  font-size: 12px;
}

.li1:hover,
.li2:hover,
.li3:hover {
  color: $primary-beta;
  font-weight: 600;
}

.itemSelected,
.subSelected, 
.subChildSelected {
  color: $primary-beta;
  font-weight: 600;
}

.expand-icon {
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  height: 20px;
  padding: 1px;
  border: 1px solid black;
}

a {
  color: inherit;
}

</style>
